import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-017bf862"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "px-4 py-2 bg-white rounded-lg dark:bg-gray-800 mb-4",
  style: {"width":"80%"}
}

import {useRoute} from 'vue-router';

import { patientStore } from '@/store/patient';
import { text } from '@fortawesome/fontawesome-svg-core';
import { storeToRefs } from 'pinia';
import { onMounted, ref } from 'vue';
import AlertModal from "@/components/AlertModalFeedback.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RemotaSection',
  emits: ["save", "edit_fisiologica"],
  setup(__props, { emit }) {

const Route = useRoute();
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);


const store = patientStore();
const { patient } = storeToRefs(store)
const showLoading = ref(false);


function SaveAnamnesi() {
  showLoading.value = true;
  store.savePaziente("AnamnesiRemota", patient.value.id_paziente)
    .then((response) => {
      showLoading.value = false;
      alertModal.value.openModal("Dati salvati con successo!", false);
    })
    .catch((error) => {
      showLoading.value = false;
      alertModal.value.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
    });}



return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("textarea", {
        id: "textRemota",
        ref: "textArea",
        rows: "10",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(patient).tbl_anamnesi_pt_remota.anamnesi_remota_contenuto) = $event)),
        class: "textStyle w-full px-0 bg-white border-0 dark:bg-gray-800 focus:ring-0 dark:text-white dark:placeholder-gray-400",
        placeholder: "",
        required: ""
      }, "\n      ", 512), [
        [_vModelText, _unref(patient).tbl_anamnesi_pt_remota.anamnesi_remota_contenuto]
      ])
    ]),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      id: "submitRemota",
      ref: "salvaBtn",
      type: "button",
      onClick: SaveAnamnesi,
      style: {"float":"right","background-color":"#1A576E"},
      class: "inline-flex items-center mt-2 py-2.5 px-4 text-base font-medium text-center text-white rounded-lg focus:ring-4 focus:ring-blue-200 dark:focus:ring-blue-900 hover:bg-blue-800"
    }, _toDisplayString(_ctx.$t("Salva")), 513)
  ], 64))
}
}

})